import type { Capability } from '@rtkwlf/capability';

/**
 * This function purposely checks against a single capability instead of a list
 * to avoid combining capabilities in the frontend (if needed this should be done in the backend).
 */
export const hasRequiredCapability = (
  requiredCapabilityId: Capability['id'],
  capabilities: Capability[] | undefined,
  defaultValue = false,
) =>
  capabilities?.map((cap) => cap.id).includes(requiredCapabilityId) ??
  defaultValue;
